import { useMutation } from "@tanstack/react-query";
import { AddPhotoImageData } from "common/types";
import User from "../../types/user";
import { postFeedbackDesktop } from "../../apis/feedback";

export function useFeedbackTicketDesktop() {
  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      accessToken,
      notes,
      images,
      rating,
      mode,
    }: {
      accessToken: string;
      notes: string;
      images: AddPhotoImageData[];
      rating?: "like" | "dislike";
      mode?: string;
    }) => {
      return postFeedbackDesktop(accessToken, notes, images, rating, mode);
    },
    onSuccess: () => {},
  });
  return { mutate, error, isPending: status === "pending", data };
}
